import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import error from "../../Assets/Projects/error.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Berikut adalah beberapa projek yang saya kerjakan baru - baru ini.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={error}
              isBlog={false}
              title="#####"
              description="######################################################################################################################################################################################################################."
              ghLink="https://github.com/"
              demoLink="https://"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={error}
              isBlog={false}
              title="#####"
              description="######################################################################################################################################################################################################################."
              ghLink="https://github.com/"
              demoLink="https://"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={error}
              isBlog={false}
              title="#####"
              description="######################################################################################################################################################################################################################."
              ghLink="https://github.com/"
              demoLink="https://"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={error}
              isBlog={false}
              title="#####"
              description="######################################################################################################################################################################################################################."
              ghLink="https://github.com/"
              demoLink="https://"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={error}
              isBlog={false}
              title="#####"
              description="######################################################################################################################################################################################################################."
              ghLink="https://github.com/"
              demoLink="https://"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={error}
              isBlog={false}
              title="#####"
              description="######################################################################################################################################################################################################################."
              ghLink="https://github.com/"
              demoLink="https://"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
